export default {
    listagem: {
        titulo_pagina: 'Lista de Exames',
        novo: 'Criar novo Exame',
        habilitado: 'Habilitado',
        desabilitado: 'Desabilitado',
        table: {
            empty: 'Nenhum Exame encontrado',
            codigo: 'Código',
            nome: 'Nome',
            mnemonico: 'Mnemônico',
            componente: 'Componente',
            metodo: 'Método',
            escala: 'Escala',
            material: 'Material',
            tempo: 'Tempo',
            editar: 'Editar'
        },
        bulk: {
            inserir: 'Inserir Bulk',
            desselecionar: 'Não é possível criar com itens selecionados!',
            selecione_um_item: 'Selecione ao menos 1 item da lista!',
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Exame',
            editar: 'Editar Exame'
        },
        fieldsets: {
            informacoes: 'Informações',
            composicao: 'Composição',
            metodo: 'Método',
            materiais_possiveis: 'Materiais Possíveis',
            mnemonicos: 'Mnemônicos Veus',
            sub_exames: 'Sub Exames',
            sinonimos: 'Sinônimos',
            loinc: 'LOINC',
            bypass: 'Bypass De x Para',
            compound: 'Perfil'
        },
        fields: {
            adicionar_subexames: 'Adicionar Subexames',
            adicionar_sinonimos: 'Adicionar Sinônimos',
            adicionar_metodo: 'Adicionar Método',
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Exame'
            },
            ordem_resultado: {
                label: 'Ordem / Resultado',
                description: 'Tipo do Exame'
            },
            nome: {
                label: 'Nome',
                description: 'Nome do Exame'
            },
            codigo: {
                label: 'Código',
                description: 'Código do Exame'
            },
            componente: {
                label: 'Componente',
                description: 'Componente do Exame'
            },
            material: {
                label: 'Material',
                description: 'Material do Exame'
            },
            metodo: {
                label: 'Método',
                description: 'Método do Exame',
                warning: {
                    duplicated: 'O método selecionado já foi adicionado!'
                }
            },
            possible_specimens: {
                label: 'Materiais Possíveis',
                integration_label: 'Integração de apoio',
                integration_unavailable: 'Integração indisponível',
                material_label: 'Material possível',
                material_placeholder: 'Informe o material possível',
                adicionar: 'Adicionar material possível',
                warning: {
                    incomplete: 'Preencha a integração de apoio e o material possível em todas as linhas.',
                    duplicated: 'Esta integração de apoio já foi adicionada. Só pode existir um material possível por exame para cada integração de apoio.'
                }
            },
            tempo: {
                label: 'Tempo',
                description: 'Tempo do Exame'
            },
            escala: {
                label: 'Escala',
                description: 'Escala do Exame'
            },
            mnemonico_veus_exam: {
                label: 'Mnemônico Veus Exame',
                description: 'Mnemônico Sub Exame'
            },
            mnemonico_veus_subexam: {
                label: 'Mnemônico Veus Sub Exame',
                description: 'Mnemônico Sub Exame'
            },
            adicionar_sub_exame_form: {
                label: 'Adicionar Sub-exame'
            },
            adicionar_sinonimos_form: {
                label: 'Adicionar Sinônimos'
            },
            specimen_complement: {
                label: 'Material Complementar',
                description: 'Ativar ou inativar bypass do material complementar'
            },
            directions: {
                ordem: 'Ordem',
                resultado: 'Resultado',
                ambos: 'Ambos'
            },
            compound: {
                label: 'Perfil (Exame Composto)',
                description: 'Informar se o exame pai na hierarquia é um perfil (exame composto)'
            },
            botao_salvar: 'Salvar Exame'
        },
        create: {
            success: 'Exame criado com Sucesso!',
            error: 'Error ao criar Exame!'
        },
        update: {
            success: 'Exame editado com Sucesso!',
            error: 'Error ao editar Exame!'
        }
    }
}
